import { render, staticRenderFns } from "./BiddingKanban.vue?vue&type=template&id=247a3248&scoped=true&"
import script from "./BiddingKanban.vue?vue&type=script&lang=js&"
export * from "./BiddingKanban.vue?vue&type=script&lang=js&"
import style0 from "./BiddingKanban.vue?vue&type=style&index=0&id=247a3248&lang=scss&scoped=true&"
import style1 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a3248",
  null
  
)

export default component.exports